/**
 * 注意事项： 请求错误命名保持统一
 * - PENDING: 请求中
 * - FULFILLED: 成功
 * - REJECTED: 失败
 */
const APP_MESSAGE = {
  GET_CAPTCHAS_FULFILLED: '发送验证码成功',
  GET_CAPTCHAS_REJECTED: '发送验证码失败',
  SET_COMPANY_PENGING: '进入中...',
  SET_COMPANY_REJECTED: '进入失败',
  ORDER_MEETING_PENDING: '预约中...',
  ORDER_MEETING_REJECTED: '预约失败',
  ORDER_MEETING_PERIOD_REJECTED: '时间无效，预约失败',
  TIME_PERIOD_IS_OCCUPIED: '会议室时间冲突',
  TIME_PERIOD_IS_DISABLED: '不在会议室可预约时间段内',
  TIME_PERIOD_IS_EXPIRED: '预约时间已过期',
  ROOM_IS_DISABLED: '会议室不可用',
  ROOM_NOT_ALLOW: '没有该会议室的预订权限',
  OPERATION_NOT_ALLOW: '会议状态不允许此操作',
  ORDER_MEETING_SUCCESS: '预约成功',
  UPDATE_MEETING_PENDING: '修改中...',
  UPDATE_MEETING_REJECTED: '修改失败',
  ADD_MEETING_MEMBER_PENDING: '添加中',
  ADD_MEETING_MEMBER_REJECTED: '添加失败',
  DELETE_MEETING_MEMBER_PENDING: '撤回中',
  DELETE_MEETING_MEMBER_REJECTED: '会议邀请撤回失败',
  DELETE_MEETING_MEMBER_SUCCESS: '会议邀请已撤回',
  ADD_MEETING_FILE_PENDING: '文件上传中',
  ADD_MEETING_FILE_REJECTED: '文件上传失败',
  GET_MEETING_FILE_PENDING: '正在获取文件信息',
  GET_MEETING_FILE_REJECTED: '获取文件信息失败',
  DELETE_MEETING_FILE_PENDING: '文件删除中',
  DELETE_MEETING_FILE_REJECTED: '文件删除失败',
  DELETE_MEETING_PENDING: '删除会议中...',
  DELETE_MEETING_SUCCESS: '删除会议成功',
  DELETE_MEETING_REJECTED: '删除会议失败',
  CANCEL_MEETING_PENDING: '取消会议中...',
  CANCEL_MEETING_SUCCESS: '取消会议成功',
  CANCEL_MEETING_REJECTED: '取消会议失败',
  REVOKE_MEETING_PENDING: '撤销申请中...',
  REVOKE_MEETING_SUCCESS: '撤销申请成功',
  REVOKE_MEETING_REJECTED: '撤销申请失败',
  CLOSE_MEETING_PENDING: '结束会议中...',
  CLOSE_MEETING_SUCCESS: '结束会议成功',
  CLOSE_MEETING_REJECTED: '结束会议失败',
  DEFAULT_PENDING: '处理中...',
  DEFAULT_SUCCESS: '操作成功',
  DEFAULT_REJECTED: '操作失败',
  LOGIN_OUT_PENDING: '登出中',
  LOGIN_OUT_FULFILLED: '登出成功',
  LOGIN_OUT_REJECTED: '登出失败',
  CONTACT_EDIT_PENDING: '修改中',
  CONTACT_EDIT_SUCCESS: '修改成功',
  CONTACT_EDIT_REJECTED: '修改失败',
  CONTACT_ADD_SUCCESS: '添加成功',
  CONTACT_ADD_PENGING: '添加中',
  CONTACT_ADD_REJECTED: '添加失败',
  CONTACT_DELETE_SUCCESS: '删除成功',
  CONTACT_DELETE_PENGING: '删除中',
  CONTACT_DELETE_REJECTED: '删除失败',
  CONTACT_LABEL_EDIT_SUCCESS: '编辑成功',
  CONTACT_LABEL_EDIT_PENGING: '编辑中',
  CONTACT_LABEL_EDIT_REJECTED: '编辑失败',
  CONTACT_LABEL_DELETE_SUCCESS: '删除标签成功',
  CONTACT_LABEL_DELETE_PENGING: '删除标签中',
  CONTACT_LABEL_DELETE_REJECTED: '删除标签失败',
  CONTACT_LABEL_CREATE_SUCCESS: '新建标签成功',
  CONTACT_LABEL_CREATE_PENGING: '新建标签中',
  CONTACT_LABEL_CREATE_REJECTED: '新建标签失败',
  ROOM_SIGN_SUCCESS: '签到成功',
  ROOM_SIGN_PENGING: '签到中',
  ROOM_SIGN_REJECTED: '签到失败',
  SERVER_EXCEPTION: '服务器异常',
  NETWORK_OFFLINE: '网络异常，请稍后再试',
  OPERATE_FREQUENCY: '操作频繁，请稍后再试',
  PUBLISH_SUMMARY_PENGING: '发送会议纪要中..',
  PUBLISH_SUMMARY_SUCCESS: '发送会议纪要成功',
  PUBLISH_SUMMARY_REJECTED: '发送会议纪要失败',
  SAVE_PENGING: '保存成功',
  SAVE_REJECTED: '保存失败',
  ORDER_MEETING_TIMELOADER: '为提高会议效率，预约会议时间不允许超过90分钟，如有疑问请联系各园区会务负责人',
  ORDER_MEETING_ERROR: '为提高会议效率，线下会议室不允许连续被同一批参会人占用，如有疑问请联系各园区会务负责人',
  APPROVAL_STATUS_EXPIRED: '状态已过期',
  APPROVAL_MEETING_MUSET_AFTER_10: '需审批会议开始时间必须是10分钟之后',
  APPROVAL_MEETING_HAVE_NO_AUDIT: '审批人缺失，无法发起申请',
  MEETING_ROOM_NEEDS_APPROVAL: '修改失败，该会议室需要审批',
  PASSWORD_SAME_IN_HISTORY: '设置密码失败，错误原因不能与上一次密码相同',
  PASSWORD_MODIFY_SUCCESS: '设置密码成功'
};

export default APP_MESSAGE;
